import {Component, HostBinding, Input} from "@angular/core";

@Component({
    selector: "fui-four-columns",
    styleUrls: ["./four-columns.component.scss"],
    templateUrl: "./four-columns.component.html",
    standalone: false
})
export class FUIFourColumnsComponent {
    @Input() followTwoCol: boolean = true;
    @Input() minColWidth: number = 150;
    @Input() minTwoColWidth: number = 300;
    @HostBinding("class.labelled") @Input() public label: string;
    @HostBinding("class.bordered") @Input() bordered: boolean;
    @Input() i18nParams: any = {};
}
